import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const ArrowBackXS = createSvgIcon(
  <path d="M5.96 11 7 9.952 3.08 6 7 2.048 5.96 1 1 6l4.96 5Z" />,
  'ArrowBackXS'
);

export { ArrowBackXS };